import { useState, type FormEvent } from "react";
import { Link } from "react-router";
import { Button } from "../../components/ui/Button";
import { FormError } from "../../components/ui/Banner";
import { useAction } from "../../hooks/useAction";
import { authApi } from "../../lib/api/auth";
import { useSession } from "../../app/session";
import { AuthLayout } from "./AuthLayout";
import { CodeField, EmailField, PasswordField } from "./fields";
import { ResendButton } from "./ResendButton";

/** Forgot password: email → code + new password → signed in. */
export function ResetPasswordPage() {
  const { refresh } = useSession();
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [sent, setSent] = useState(false);

  const send = useAction(async () => { await authApi.sendCode(email, "forget-password"); setSent(true); });
  const reset = useAction(async () => {
    await authApi.resetPassword(email, otp, password);
    await authApi.signIn(email, password);
    await refresh();
  });

  const submit = (e: FormEvent) => { e.preventDefault(); void (sent ? reset.run() : send.run()); };
  return (
    <AuthLayout title="Reset password" footer={<Link to="/sign-in">back to sign in</Link>}>
      <form onSubmit={submit} className="flex flex-col gap-4.5">
        {sent ? (
          <>
            <CodeField email={email} value={otp} onChange={setOtp} />
            <PasswordField value={password} onChange={setPassword} isNew label="new password" />
          </>
        ) : (
          <>
            <p className="text-muted">We'll email you a code. If there's no account for this email, nothing arrives.</p>
            <EmailField value={email} onChange={setEmail} autoFocus />
          </>
        )}
        <FormError message={send.error ?? reset.error} />
        <Button type="submit" variant="primary" pending={send.pending || reset.pending}>
          {sent ? "set password and sign in →" : "email me a code →"}
        </Button>
        {sent && <ResendButton onResend={() => authApi.sendCode(email, "forget-password")} />}
      </form>
    </AuthLayout>
  );
}
